// RFC 4180: un valor se cita si trae coma, comillas o salto de linea, y las
// comillas internas se duplican. Sin esto cualquier campo de texto libre
// (motivo_error, por ejemplo) descuadra las columnas de su fila.
// null/undefined salen como celda vacia y no como la palabra "null".
function escapeCSV(value) {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\n\r]/.test(text) ? '"' + text.replace(/"/g, '""') + '"' : text;
}

function convertArrayOfObjectsToCSV(array) {

  array=array.sort(function (a, b) {
      if (a.empresa > b.empresa) {
        return 1;
      }
      if (a.empresa < b.empresa) {
        return -1;
      }
      return 0;
    });
  let result;
  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = Object.keys(array[0]);
  result = '';
  result += keys.map(escapeCSV).join(columnDelimiter);
  result += lineDelimiter;
  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter;
      result += escapeCSV(item[key]);
      ctr++;
    });
    result += lineDelimiter;
  });
  return result;

}

export default function downloadCSV(array, filename = null) {
const link = document.createElement('a');
let csv = convertArrayOfObjectsToCSV(array);
if (csv == null) return;

const timestamp = new Date().toISOString().replace(/:/g, "-");
if (!filename) {
  filename = `export_${timestamp}.csv`;
}
csv = "\ufeff" + csv;
// encodeURI no escapa '#', asi que una celda con ese caracter dejaba fuera del
// archivo todo lo que viniera despues. encodeURIComponent si lo escapa.
link.setAttribute('href', `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`);
link.setAttribute('download', filename);
link.click();
}
